<template>
  <v-card raised class="mb-4" elevation="5">
    <v-layout pa-4>
      <v-flex sm2 class="d-flex justify-center align-center">
        <v-icon size="80">mdi-account-circle-outline</v-icon>
      </v-flex>
      <v-flex sm10>
        <v-layout wrap>
          <v-flex sm8>
            <h1 class="grey--text text--darken-1">{{ user.orgName }}</h1>
          </v-flex>
          <v-flex sm4 class="text-end">
            <v-switch
              @change="updateActive"
              v-model="active"
              dense
              class="mt-0 switch"
              color="blue"
            ></v-switch>
            <v-icon @click="toPersonal" class="mr-2">mdi-account-outline</v-icon>
            <v-icon @click="dialog = true" class="mr-2">mdi-pencil-outline</v-icon>
            <v-icon @click="dialogDelete = true" class="mr-2">mdi-close</v-icon>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <p class="grey--text text--darken-1">{{ user.name }}</p>
          </v-flex>
          <v-flex>
            <p class="grey--text text--darken-1">{{ user.phone }}</p>
          </v-flex>
          <v-flex>
            <p class="grey--text text--darken-1">{{ user.email }}</p>
          </v-flex>
          <v-flex>
            <p
              class="grey--text text--darken-1"
            >Empleados : {{ user.totalParticipants }} / {{user.maxParticipants}}</p>
          </v-flex>
          <v-flex>
            <p
              class="grey--text text--darken-1"
            >Cuestionarios completados : {{ user.totalResolved }}</p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Ventana para editar cliente -->
    <v-dialog v-model="dialog" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Editar Cliente</v-card-title>

        <v-form @submit="send" ref="formClient">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="name" label="Nombre" :rules="requiredRule"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="orgName"
                      label="Nombre de la organización"
                      :rules="requiredRule"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="email"
                      label="Correo Electrónico"
                      :rules="emailRule"
                      type="email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="phone"
                      label="Teléfono"
                      :rules="requiredRule"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="maxParticipants"
                      label="Máximo de empleados"
                      :rules="requiredRule"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">cancelar</v-btn>
            <v-btn color="primary" text type="submit">Actualizar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Ventana para editar empleados -->
    <v-dialog v-model="dialogParticipants" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Editar empleados</v-card-title>

        <v-form @submit.prevent="sendParticipants" ref="formParticipant">
          <v-container>
            <v-layout wrap>
              <v-flex sm12>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="optionType" label="Tipo" :rules="requiredRule"></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field v-model="optionName" label="Rango" :rules="requiredRule"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialogParticipants = false">cancelar</v-btn>
            <v-btn color="primary" text type="submit">Actualizar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Ventana para eliminar -->
    <v-dialog v-model="dialogDelete" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Eliminar cliente</v-card-title>

        <v-card-text class="title">¿Estás seguro de eliminar a este usuario?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false">cancelar</v-btn>
          <v-btn color="primary" text @click="deleteUser">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  name: "ClientCard",
  props: {
    user: Object
  },
  data() {
    return {
      dialog: false,
      dialogDelete: false,
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      emailRule: [
        v => !!v || "Este campo es obligatorio",
        v => /.+@.+\..+/.test(v) || "El correo debe ser valido"
      ],
      name: this.user.name,
      orgName: this.user.orgName,
      email: this.user.email,
      phone: this.user.phone,
      maxParticipants: this.user.maxParticipants,
      active: this.user.active,
      snackbar: false,
      message: "",
      dialogParticipants: false,
      optionName: "",
      optionType: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      if (this.$refs.formClient.validate()) {
        let data = {
          idUser: this.user.idUser,
          name: this.name,
          orgName: this.orgName,
          email: this.email,
          phone: this.phone,
          maxParticipants: this.maxParticipants,
          type: this.user.type,
          active: this.user.active,
          idUserVerify: sessionStorage.getItem("authorization")
        };

        axios
          .post(this.host + "/users/update.php", this.createFormData(data))
          .then(response => {
            if (response.data.status) {
              this.dialog = false;
              this.$emit("updateUsers");
            }
            this.message = response.data.message;
            this.snackbar = true;
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    sendParticipants() {
      if (this.$refs.formParticipant.validate()) {
        let data = {
          idUser: sessionStorage.getItem("authorization"),
          optionName: this.optionName,
          optionType: this.optionType
        };

        axios
          .post(
            this.host + "/users/updateparticipants.php",
            this.createFormData(data)
          )
          .then(response => {
            if (response.data.status) {
              this.dialog = false;
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    updateActive() {
      let data = {
        idUserActive: this.user.idUser,
        active: this.active,
        idUser: sessionStorage.getItem("authorization")
      };
      axios
        .post(this.host + "/users/updateactive.php", this.createFormData(data))
        .then(response => {
          if (response.data.status) {
            this.$emit("updateUsers");
          }
          this.snackbar = true;
          this.message = response.data.message;
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteUser() {
      let data = {
        idUserDelete: this.user.idUser,
        idUser: sessionStorage.getItem("authorization")
      };
      axios
        .post(this.host + "/users/delete.php", this.createFormData(data))
        .then(response => {
          this.dialogDelete = false;
          this.$emit("updateUsers");
          if (!response.data.status) {
            this.snackbar = true;
            this.message = response.data.message;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    toPersonal() {
      this.$router.push(
        `/admin/personaldataoptions/${this.user.idUser}/${this.user.orgName}`
      );
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>
<style scoped>
.switch {
  width: 50px;
  display: inline-block;
}
</style>